<div class="list-page-header">
  @if (showPageTitle) {
    <div class="list-page-title">Debit Authorizations</div>
  }

  <div class="list-page-controls">
    <rkt-table-search (changed)="onSearch($event)" placeholder="Search"></rkt-table-search>
  </div>

  <div class="list-filters">
    <button type="button" class="table-header-filter-btn" (click)="filterMenu.toggle($event)" #filterBtn>
      <rkt-icon name="filter" class="table-header-filter-icon"></rkt-icon>
      Filter
      @if (activeFiltersCount) {
        <span class="table-header-filter-counter">{{ activeFiltersCount }}</span>
      }
    </button>
  </div>
</div>

<div class="debit-auth-list">
  <rkt-table
    [rows]="(registrations$ | async)!"
    [columns]="columns"
    (fetchData)="getRegistrations($event)"
    [count]="(totalElements$ | async)!"
    [loadingIndicator]="(loading$ | async)!"
    [offset]="activePage"
    [rowHeight]="64"
    dateTimeFormat="MM/dd/yy HH:mm"
    [messages]="{ emptyMessage: 'No Registrations found.' }"
    emptyValuePlaceholder="--"
    [sortParam]="sortParams"
    (rowActivated)="onRowClick($event)"
    [isItemsAlignCenter]="true"
  ></rkt-table>
</div>

<app-filter-menu
  #filterMenu
  [initialValues]="activeFilters"
  [filters]="filters"
  (opened)="filterBtn.classList.add('opened')"
  (closed)="filterBtn.classList.remove('opened')"
  (saved)="applyFilters($event)"
></app-filter-menu>
